// extracted by mini-css-extract-plugin
module.exports = {"cartModalContainer":"cart-modal_cartModalContainer__I9Y32","cartFooter":"cart-modal_cartFooter__Em-Rb","empty":"cart-modal_empty__99U7U"};